import React from 'react';
import ArticleLayout, { Labeled } from '../components/site/ArticleLayout';
import useLang from '../i18n/useLang';
import BlogFioriImage from '../images/BlogFiori.png';

const BlogFiori = () => {
  const { t } = useLang();

  return (
    <ArticleLayout
      title={t('blogs.blogFiori.header1')}
      image={BlogFioriImage}
      imageAlt={t('blogs.blogFiori.imageAlt', { defaultValue: t('blogs.blogFiori.header1') })}
      imageFit="contain"
      author={t('blogs.blogMaimPage.Yaniv')}
      date="2024-11-12"
    >
      <p>{t('blogs.blogFiori.IntroParagraph')}</p>

      <h2>{t('blogs.blogFiori.header2')}</h2>
      <ul>
        <li><Labeled text={t('blogs.blogFiori.feature1')} /></li>
        <li><Labeled text={t('blogs.blogFiori.feature2')} /></li>
        <li><Labeled text={t('blogs.blogFiori.feature3')} /></li>
        <li><Labeled text={t('blogs.blogFiori.feature4')} /></li>
      </ul>

      <h2>{t('blogs.blogFiori.header3')}</h2>
      <p>{t('blogs.blogFiori.benefitsIntro')}</p>
      <ol>
        <li><Labeled text={t('blogs.blogFiori.benefit1')} /></li>
        <li><Labeled text={t('blogs.blogFiori.benefit2')} /></li>
        <li><Labeled text={t('blogs.blogFiori.benefit3')} /></li>
        <li><Labeled text={t('blogs.blogFiori.benefit4')} /></li>
      </ol>

      <h2>{t('blogs.blogFiori.header4')}</h2>
      <p>{t('blogs.blogFiori.industry4Paragraph')}</p>

      <h2>{t('blogs.blogFiori.header5')}</h2>
      <p>{t('blogs.blogFiori.conclusionParagraph')}</p>
    </ArticleLayout>
  );
};

export default BlogFiori;
